import {IntlShape} from "react-intl";

const getYesMessage = (intl: IntlShape): string => {
  return intl.formatMessage({
    id: "displayHelpers.displayYesOrNo.yes",
    defaultMessage: "Yes"
  });
}

const getNoMessage = (intl: IntlShape): string => {
  return intl.formatMessage({
    id: "displayHelpers.displayYesOrNo.no",
    defaultMessage: "No"
  });
}

export const DisplayYesOrNo = (answer: boolean, intl?: IntlShape): string => {
  if (!intl) {
    return answer ? "Yes" : "No";
  }

  return answer
    ? getYesMessage(intl)
    : getNoMessage(intl);
}